import { TStoreState } from 'redux/types';
import { TPgListRequest } from 'services/api/paymentGateway/types';
import { TPgSaveKey, TPgSettingsStore } from './types';

export const selectPgSettingsState = (state: TStoreState): TPgSettingsStore => state.pgSettings;

export const selectPgServices = (state: TStoreState) => state.pgSettings.services;
export const selectPgServicesLoading = (state: TStoreState) => state.pgSettings.servicesLoading;

export const selectPgServiceTypeMappings = (state: TStoreState) =>
	state.pgSettings.serviceTypeMappings;
export const selectPgServiceTypeMappingsLoading = (state: TStoreState) =>
	state.pgSettings.serviceTypeMappingsLoading;

export const selectPgPayabilityRules = (state: TStoreState) => state.pgSettings.payabilityRules;
export const selectPgPayabilityRulesLoading = (state: TStoreState) =>
	state.pgSettings.payabilityRulesLoading;

export const selectPgLegalEntities = (state: TStoreState) => state.pgSettings.legalEntities;
export const selectPgLegalEntitiesLoading = (state: TStoreState) =>
	state.pgSettings.legalEntitiesLoading;

export const selectPgAirwallexAccounts = (state: TStoreState) => state.pgSettings.airwallexAccounts;
export const selectPgAirwallexAccountsLoading = (state: TStoreState) =>
	state.pgSettings.airwallexAccountsLoading;

export const selectPgFeeMatrix = (state: TStoreState) => state.pgSettings.feeMatrix;
export const selectPgFeeMatrixLoading = (state: TStoreState) => state.pgSettings.feeMatrixLoading;

export const selectPgFxSettings = (state: TStoreState) => state.pgSettings.fxSettings;
export const selectPgFxSettingsLoading = (state: TStoreState) => state.pgSettings.fxSettingsLoading;

export const selectPgSchedule = (state: TStoreState) => state.pgSettings.schedule;
export const selectPgScheduleLoading = (state: TStoreState) => state.pgSettings.scheduleLoading;

export const selectPgClientAccess = (state: TStoreState) => state.pgSettings.clientAccess;
export const selectPgClientAccessLoading = (state: TStoreState) =>
	state.pgSettings.clientAccessLoading;

export const selectPgRecurringRuns = (state: TStoreState) => state.pgSettings.recurringRuns;
export const selectPgRecurringRunsLoading = (state: TStoreState) =>
	state.pgSettings.recurringRunsLoading;
export const selectPgRecurringRunsLastParams = (state: TStoreState): TPgListRequest | null =>
	state.pgSettings.recurringRunsLastParams;

export const selectPgRecurringCycles = (state: TStoreState) => state.pgSettings.recurringCycles;
export const selectPgRecurringCyclesLoading = (state: TStoreState) =>
	state.pgSettings.recurringCyclesLoading;

/** `useSelector(selectPgSaveLoading('fees'))`. */
export const selectPgSaveLoading =
	(key: TPgSaveKey) =>
	(state: TStoreState): boolean =>
		!!state.pgSettings.saveLoading[key];

/** `useSelector(selectPgSaveSuccess('fees'))`. */
export const selectPgSaveSuccess =
	(key: TPgSaveKey) =>
	(state: TStoreState): boolean =>
		!!state.pgSettings.saveSuccess[key];
